"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _disclosure = _interopRequireDefault(require("./disclosure"));
var _base = _interopRequireDefault(require("../../atomic/texts/base"));
var _util = require("../../../util");
require("./_styles.scss");
var BLOCK_CLASS = 'pf-page-disclosure';
var bem = (0, _util.klass)(BLOCK_CLASS);
var Disclosures = function Disclosures(_ref) {
  var disclosuresContent = _ref.disclosuresContent;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: BLOCK_CLASS
  }, disclosuresContent.map(function (content) {
    return /*#__PURE__*/_react.default.createElement(_disclosure.default, Object.assign({
      key: content.heading
    }, content));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: bem('footnote')
  }, /*#__PURE__*/_react.default.createElement(_base.default, null, "Credit Account offers are subject to credit approval."), /*#__PURE__*/_react.default.createElement(_base.default, null, "LendingClub Patient Solutions Credit Accounts are issued by Comenity Capital Bank.")));
};
Disclosures.propTypes = {
  disclosuresContent: _propTypes.default.arrayOf(_propTypes.default.shape({
    heading: _propTypes.default.string,
    description: _propTypes.default.string,
    superscript: _propTypes.default.string
  })).isRequired
};
var _default = Disclosures;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');